import {createAutoStartSetting} from './createAutoStartSetting';

const {SettingComponent: AutoStartSetting} = createAutoStartSetting();

export default AutoStartSetting;
